import api from '../config/api';

export const getProjectDetail = id => {
    const res = api.get(`/projects/${id}/`);
    return res;
};
